import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MainNavItemsService } from '../../services/main-nav-items.service';
import { MainNavService } from '../../services/main-nav.service';

@Component({
  selector: 'sh-main-nav-business-desktop-for-user',
  templateUrl: './main-nav-business-desktop-for-user.component.html',
  styleUrl: './main-nav-business-desktop-for-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MainNavBusinessDesktopForUserComponent {
  @Input()
  bigger = false;

  constructor(
    public nav: MainNavService,
    public items: MainNavItemsService
  ) {}
}
